export const REDUCER_NAME = "brandSlice";

export interface iBrand {
  id: string;
  name: string;
  description: string;
  image_url?: string | null;
  created_at: string;
  updated_at: string;
  logo: string;
}

export interface iBrandState {
  isLoading: boolean;
  brand: iBrand | null;
  errorMessage: string | null;
  brandList: iBrand[];
}